import { Loader } from '@seen/react'
import { type JSX, lazy, Suspense } from 'react'

// Admin-only route (/organizations), reached by explicit navigation. App.tsx's
// <Outlet /> already supplies Suspense + an ErrorBoundary; the local Suspense
// keeps this safe if it is ever mounted somewhere without one.
const OrganizationsPageImpl = lazy(() =>
  import('#src/pages/organizations/OrganizationsPageImpl.tsx').then((m) => ({
    default: m.OrganizationsPageImpl,
  }))
)

export function OrganizationsPage(): JSX.Element {
  return (
    <Suspense fallback={<Loader />}>
      <OrganizationsPageImpl />
    </Suspense>
  )
}
